import React, { useCallback, useState } from 'react';
import { useDispatch, useMappedState } from 'redux-react-hook';
import _find from 'lodash/find';
import _map from 'lodash/map';
import _get from 'lodash/get';
import _size from 'lodash/size';
import _includes from 'lodash/includes';
import { AdditionalInfo } from 'styles/elements/infoBoxes/info';
import { answerSingleChoice } from 'redux/actions/consultation/answer';
import { STRINGS } from 'config';
import SelectOption from 'styles/blocks/selectOption';
import Question from 'styles/blocks/question';
import SelectOptionFlexible from 'styles/blocks/selectOption/flexible';
import { Select } from './select';
import { PainScale } from './painScale';
import { SelectFlexible } from './flexible';

/*
* Question guidance appears withing the answer means refactor is needed. isGuidanceTextShownAboveQuestion shouldn't need to be here either.
* */

export function SingleSelect({ question, isMounted, isGuidanceTextShownAboveQuestion }) {
  const mapState = useCallback(state => ({
    isClinicalReviewMode: state.flagsReducer.isClinicalReviewMode,
    validAnswers: state.consultationReducer.question.answers,
    singleSelectedAnswer: state.consultationReducer.singleSelectedAnswer,
    isLoading: state.consultationReducer.isLoading,
    isForwardNavigation: state.consultationReducer.isForwardNavigation,
    product: state.consultationReducer.product,
  }), []);
  const { isClinicalReviewMode, validAnswers, singleSelectedAnswer, isLoading, isForwardNavigation, product } = useMappedState(mapState);

  function createMarkup(text) {
    return { __html: text };
  }
  // actions to update value
  const dispatch = useDispatch();
  const [selectedAnswer] = useState(singleSelectedAnswer);
  const [tags] = useState(() => _get(question, 'tags[0]', null));
  const [answersListSize] = useState(() => _size(question.answers));
  const setValue = useCallback(answer => {
    if (_find(validAnswers, answer) && !isLoading) {
      dispatch(answerSingleChoice(answer), []);
    }
  }, [dispatch, validAnswers, isLoading]);

  switch (tags) {
    case STRINGS.TAGS.QUESTION.PAIN_SCALE: {
      return (
        <SelectOption.GroupWrapper>
          {_map(question.answers, (answer, index) => (
            <PainScale
              key={`emojiPainScale-${index}`}
              answer={answer}
              isClinicalReviewMode={isClinicalReviewMode}
              selected={selectedAnswer && selectedAnswer.answerId === answer.answerId}
              onSelectOption={setValue}
            />
          ))}
        </SelectOption.GroupWrapper>
      );
    }
    case STRINGS.TAGS.QUESTION.SELECT_FLEXIBLE: {
      return (
        <>
          <SelectOptionFlexible.GroupWrapper answersListSize={answersListSize}>
            {_map(question.answers, (answer, index) => (
              <SelectOptionFlexible.FieldWrapper key={`singleSelect-${index}`} secondary={_includes(answer.tags, STRINGS.TAGS.ANSWER.SELECT_SECONDARY)}>
                <SelectFlexible
                  answer={answer}
                  index={index}
                  isMounted={isMounted}
                  onSelectOption={setValue}
                  isClinicalReviewMode={isClinicalReviewMode}
                  selected={selectedAnswer && selectedAnswer.answerId === answer.answerId}
                  showSpinner={isLoading && singleSelectedAnswer.answerId === answer.answerId && isForwardNavigation}
                  product={product}
                  secondary={_includes(answer.tags, STRINGS.TAGS.ANSWER.SELECT_SECONDARY)}
                />
                <AdditionalInfo infoGroup={[answer.guidanceScript]} />
              </SelectOptionFlexible.FieldWrapper>
            ))}
          </SelectOptionFlexible.GroupWrapper>
          {question.guidanceScript && !isGuidanceTextShownAboveQuestion && <Question.ETriageHelpLabel dangerouslySetInnerHTML={createMarkup(question.guidanceScript)} />}
        </>
      );
    }
    default:
      return (
        <>
          <SelectOption.GroupWrapper answersListSize={answersListSize}>
            {_map(question.answers, (answer, index) => (
              <SelectOption.FieldWrapper key={`singleSelect-${index}`} answersListSize={answersListSize}>
                <Select
                  answer={answer}
                  index={index}
                  isMounted={isMounted}
                  onSelectOption={setValue}
                  isClinicalReviewMode={isClinicalReviewMode}
                  selected={selectedAnswer && selectedAnswer.answerId === answer.answerId}
                  showSpinner={isLoading && singleSelectedAnswer.answerId === answer.answerId && isForwardNavigation}
                  product={product}
                />
                <AdditionalInfo infoGroup={[answer.guidanceScript]} />
              </SelectOption.FieldWrapper>
            ))}
          </SelectOption.GroupWrapper>
          {question.guidanceScript && !isGuidanceTextShownAboveQuestion && <Question.ETriageHelpLabel dangerouslySetInnerHTML={createMarkup(question.guidanceScript)} />}
        </>
      );
  }
}
